export enum ForumEditorToolbarOptionType {
  Action = "action",
  Divider = "divider",
}

export type ForumEditorToolbarActionOption = {
  type: ForumEditorToolbarOptionType.Action;
  label: string;
  actionFn: () => void;
  isActiveFn?: () => boolean;
  tooltipFn?: () => string | null;
};

export type ForumEditorToolbarDividerOption = {
  type: ForumEditorToolbarOptionType.Divider;
};

export type ForumEditorToolbarOption =
  | ForumEditorToolbarActionOption
  | ForumEditorToolbarDividerOption;
